import axios from 'axios';
import {
    hospitalRequest,
    hospitalDataSuccess,
    contactCreateSuccess,
    contactUpdateSuccess,
    contactDeleteSuccess,
    docCreateSuccess,
    docDeleteSuccess,
    categoryCreateSuccess,
    categoryDeleteSuccess,
    hospitalFail
} from '../slices/hospitalSlice';

export const getHospitalData = () => async (dispatch) => {
    try {
        dispatch(hospitalRequest());
        const { data } = await axios.get('/api/v1/hospital');
        dispatch(hospitalDataSuccess(data));
    } catch (error) {
        dispatch(hospitalFail(error.response?.data?.message || error.message));
    }
};

export const addHospitalContact = (contactData) => async (dispatch) => {
    try {
        dispatch(hospitalRequest());
        const { data } = await axios.post('/api/v1/hospital/contact', contactData);
        dispatch(contactCreateSuccess(data.contact));
    } catch (error) {
        dispatch(hospitalFail(error.response?.data?.message || error.message));
    }
};

export const updateHospitalContact = (id, contactData) => async (dispatch) => {
    try {
        dispatch(hospitalRequest());
        const { data } = await axios.put(`/api/v1/hospital/contact/${id}`, contactData);
        dispatch(contactUpdateSuccess(data.contact));
    } catch (error) {
        dispatch(hospitalFail(error.response?.data?.message || error.message));
    }
};

export const deleteHospitalContact = (id) => async (dispatch) => {
    try {
        dispatch(hospitalRequest());
        await axios.delete(`/api/v1/hospital/contact/${id}`);
        dispatch(contactDeleteSuccess(id));
    } catch (error) {
        dispatch(hospitalFail(error.response?.data?.message || error.message));
    }
};

export const addHospitalDocument = (formData) => async (dispatch) => {
    try {
        dispatch(hospitalRequest());
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        const { data } = await axios.post('/api/v1/hospital/document', formData, config);
        dispatch(docCreateSuccess(data.document));
    } catch (error) {
        dispatch(hospitalFail(error.response?.data?.message || error.message));
    }
};

export const deleteHospitalDocument = (id) => async (dispatch) => {
    try {
        dispatch(hospitalRequest());
        await axios.delete(`/api/v1/hospital/document/${id}`);
        dispatch(docDeleteSuccess(id));
    } catch (error) {
        dispatch(hospitalFail(error.response?.data?.message || error.message));
    }
};

export const addHospitalCategory = (categoryData) => async (dispatch) => {
    try {
        dispatch(hospitalRequest());
        const { data } = await axios.post('/api/v1/hospital/category', categoryData);
        dispatch(categoryCreateSuccess(data.category));
    } catch (error) {
        dispatch(hospitalFail(error.response?.data?.message || error.message));
    }
};

export const deleteHospitalCategory = (id) => async (dispatch) => {
    try {
        dispatch(hospitalRequest());
        await axios.delete(`/api/v1/hospital/category/${id}`);
        dispatch(categoryDeleteSuccess(id));
    } catch (error) {
        dispatch(hospitalFail(error.response?.data?.message || error.message));
    }
};
